import { SupplierManagement } from "./equipment/SupplierManagement";

export const SupplierManagementTab = () => {
  return <SupplierManagement />;
};